// extracted by mini-css-extract-plugin
export default {"base":"vp_kVKZo","content":"vp_daJgm","title":"vp_j23V3","wrapper":"vp_mvAN_","footer":"vp_iyoHv","overlay":"vp_tO62T","isVisible":"vp_n3GEa"};